// extracted by mini-css-extract-plugin
export default {"loadingComponent":"style_loadingComponent__cn9dB","withBackground":"style_withBackground__UFdmI"};